import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgMildIrritationSelectedEmojiSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M23.75 8C15.07 8 8 15.07 8 23.75S15.07 39.5 23.75 39.5 39.5 32.43 39.5 23.75 32.43 8 23.75 8Zm5.92 24.63c-1.24 0-1.88-.87-2.35-1.51-.39-.53-.59-.76-.85-.76-.34 0-.48.17-.84.79-.34.59-.86 1.49-2.04 1.49-1.09 0-1.59-.86-1.94-1.49-.35-.61-.5-.8-.76-.8-.2 0-.38.23-.7.72-.43.66-1.02 1.57-2.28 1.57-.41 0-.75-.34-.75-.75s.34-.75.75-.75c.4 0 .61-.26 1.02-.89.39-.59.92-1.4 1.95-1.4 1.18 0 1.71.94 2.07 1.56.31.54.45.73.64.73.28 0 .41-.16.74-.74.35-.61.88-1.54 2.14-1.54 1.05 0 1.61.76 2.06 1.37.46.63.71.9 1.14.9.41 0 .75.34.75.75s-.34.75-.75.75Z",
    fill: "currentColor"
  }));
}

export { SvgMildIrritationSelectedEmojiSecondary as default };
